import React from 'react'
import StrumentiServiziTemplate from '../../components/template/StrumentiServiziTemplate/StrumentiServiziTemplate'
import { PAGINEDETAIL } from '../../utils/endpoint'
import PropTypes from 'prop-types'
import { api, getApiClient } from '../../utils'

const StrumentiServizi = ({ page }) => {
  return (
    <>
      <StrumentiServiziTemplate page={page} />
    </>
  )
}

export async function getServerSideProps({ locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'strumenti-servizi',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}

StrumentiServizi.propTypes = {
  page: PropTypes.object,
}

export default StrumentiServizi
